import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import "./i18n";

// Sign-in is the in-app Olene form (SRP against the Cognito pool named by
// REACT_APP_PAYCLEAR_USER_POOL_ID / REACT_APP_COGNITO_CLIENT_ID); see
// src/auth/. REACT_APP_AUTHORITY, REACT_APP_COGNITO_DOMAIN and
// REACT_APP_REDIRECT_URI are hosted-UI leftovers and are no longer read.
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
